import {
  NgModule,
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ChangeDetectorRef,
  AfterViewChecked,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { ObjectUtils } from 'primeng/utils';

export const CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RfCheckboxComponent),
  multi: true,
};

@Component({
  selector: 'rf-checkbox',
  templateUrl: 'checkbox.component.html',
  providers: [CHECKBOX_VALUE_ACCESSOR],
  standalone: false,
})
export class RfCheckboxComponent extends Checkbox {
  // PrimeNG 16 queries "#input" (used by focus()); this template names the native input "#cb".
  @ViewChild('cb') inputViewChild: ElementRef;

  // Was an override of PrimeNG 15 onClick(event, checkbox, focus); toggling happens via the native input (change).
  onBoxClick(event: any) {
    event.stopPropagation();
  }

  // PrimeNG 16 removed handleChange/updateModel; this is the PrimeNG 15.3 logic.
  handleChange(event: Event) {
    if (!this.readonly) {
      let newModelValue;
      if (!this.binary) {
        if (this.checked()) newModelValue = this.model.filter((val: any) => !ObjectUtils.equals(val, this.value));
        else newModelValue = this.model ? [...this.model, this.value] : [this.value];
        this.onModelChange(newModelValue);
        this.model = newModelValue;
        if (this.formControl) {
          this.formControl.setValue(newModelValue);
        }
      } else {
        newModelValue = this.checked() ? this.falseValue : this.trueValue;
        this.model = newModelValue;
        this.onModelChange(newModelValue);
      }
      this.onChange.emit({ checked: newModelValue, originalEvent: event });
    }
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RfCheckboxComponent],
  declarations: [RfCheckboxComponent],
})
export class RfCheckboxModule {}
